import { AbstractControl, AsyncValidatorFn, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Observable, of, map } from 'rxjs';

export const isEmpty = (obj: any) =>{
    if (obj === null || obj === undefined ) {
        return true;
    }
    if(obj === '') {
      return true;
    }
    return false;
  };
 
export const isEmptyObject = (obj: any) => {
    if (obj === null || obj === undefined ) {
        return true;
    } 
    if(Object.keys(obj).length === 0) {
      return true;
    }
    return false;
  };


export const extractValues = (obj:any, keys:any) => {
    return keys.reduce((result:any, key:any) => {
        if (obj.hasOwnProperty(key)) {
            result[key] = obj[key];
        }
        return result;
    }, {});
}




// Custom Async Validator
// Custom Async Validator
// Custom Async Validator
 

export function asyncMatchValidator(matchTo: string): AsyncValidatorFn {
  return (control: AbstractControl): Observable<ValidationErrors | null> => {
    if (!control.parent) {
      return of(null);
    }
    const matchControl = control.parent.get(matchTo);
    return matchControl?.valueChanges.pipe(
      map(() => control.value === matchControl?.value ? null : { matching: true })
    ) || of(null);
  };
}

export function matchValidator(matchTo: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    return control.parent && control.parent.get(matchTo)?.value === control.value
      ? null
      : { matching: true };
  };
}



// Custom Conditional Validator
export function passwordConditionalValidator(): ValidatorFn {
  return (formGroup: AbstractControl): ValidationErrors | null => {
    const changePassword = formGroup.get('changePassword')?.value;
    const password = formGroup.get('password');
    const passwordConfirmation = formGroup.get('password_confirmation');

    if (changePassword) {
      password?.setValidators([Validators.required, Validators.minLength(6)]);
      passwordConfirmation?.setValidators([Validators.required, matchValidator('password')]);
    } else {
      password?.setValidators(null);
      passwordConfirmation?.setValidators(null);
    }

    password?.updateValueAndValidity({ onlySelf: true });
    passwordConfirmation?.updateValueAndValidity({ onlySelf: true });

    return null;
  }
}

export const getCurrentDate = () => {
  const date = new Date();
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const year = date.getFullYear();
  
  return `${year}-${month}-${day}`;
}



